<script>
import Roles from '@/mixins/Roles'
import Filters from '@/mixins/Filters'
export default {
    name: 'StatsFilters',

    mixins: [Roles, Filters],

    data() {
        return {
            model: {
                user_id: 1,
                date_from: null,
                date_to: null,
            },
        }
    },
}
</script>

<template lang="pug">
div
    acrm-input-user-select(v-model="model.user_id") {{ $t('USERS.USER')}}
    acrm-date-picker(v-model="model.date_from") {{ $t('ORDERS.TRANS_DATE_FROM') }}
    acrm-date-picker(v-model="model.date_to") {{ $t('ORDERS.TRANS_DATE_TO') }}
    .separator-top.pt-3.mt-5
    .row.mb-3
        .col-24.col-md-12
            acrm-input-button(block @click="filter").mb-2.mb-md-0 {{ $t('FILTER.FILTER') }}
        .col-24.col-md-12
            acrm-input-button(variant="link" block @click="clear") {{ $t('FILTER.DELETE_FILTER') }}
</template>
